<app-header (toggleLeftSidenav)="leftMenu = true" (toggleRightSidenav)="rightMenu = true" [userBalance]="userBalance"
  [username]="username"></app-header>

<!-- Lobby mode (the GoldenRace provider page) gives the vendor application the
     whole content width: no fixed container gutters, no top spacer, and the
     side columns + streaming bar below are not rendered at all.

     It also drops the two things that reserve space UNDER the game: the
     container's min-height (the frame is already sized to the viewport, so a
     floor below it can only add dead space) and the row's bottom padding —
     with pb-5 the footer sat a full 3rem below the frame, which on a phone is
     a black strip you have to scroll past. -->
<div [ngClass]="isProviderLobby ? 'container-fluid px-0' : 'container-xl min-container-height'">
  <div class="space-10" *ngIf="!isProviderLobby"></div>
  <!-- no-gutters in lobby mode: the row's negative margins would otherwise
       push 30 px past a container with no padding — a horizontal scrollbar on
       a phone, and a game that is never quite edge to edge. -->
  <div [ngClass]="isProviderLobby ? 'pb-0 row no-gutters' : 'pb-5 row'">
    <div class="col-md-3 col-xl-2 order-2 order-md-1 sticky-position" [ngClass]="{ 'd-none d-xl-block': !isHome }"
      *ngIf="!isProviderLobby"
      #slipContainerLeft>
      <div class="space-10 hide-large"></div>
      <app-calendar></app-calendar>
      <div class="space-10"></div>
      <app-quick-view></app-quick-view>
      <div class="space-30"></div>
    </div>

    <div class="order-1 order-md-2" [ngClass]="isProviderLobby ? 'col-12' : 'col-12 col-md router-height'"
      [class.streaming-column]="streamingEnabled">
      <!-- <div class="maintenence" *ngIf="!maintanceHide">
        <span>
          {{ 'HOME.MAINTANANCE' | translate }}
        </span>
      </div> -->
      <!-- Market announcement: above the streaming/slider block so it is the
           first thing in the content column, but still in the scroll flow. -->
      <app-home-announcement *ngIf="isHome"></app-home-announcement>

      <!-- The Live Streaming bar is race context. Inside the provider lobby it
           is an unrelated dropdown sitting on top of the game. -->
      <app-streaming-player *ngIf="!isProviderLobby"></app-streaming-player>

      <app-quarte-races class="d-xl-none d-sm-block"
        *ngIf="isHome && !router.url.includes('races/all') || router.url.includes('next-races/all')"
        [collapsed]="bettingSlipStatus">
      </app-quarte-races>

      <router-outlet></router-outlet>
    </div>

    <div class="col-lg-3 col-xl-2 order-md-3 d-none d-xl-block" *ngIf="!isProviderLobby">
      <div [style.position]="activeBetSlipIndex === 0 ? 'sticky' : 'relative'" class="slip-container">
        <p-accordion [(activeIndex)]="activeBetSlipIndex" [ngClass]="{ 'd-none': !bettingSlipStatus }">
          <p-accordionTab header="{{ 'BETTING_SLIP.YOUR_BETTING_SLIP' | translate }}">
            <div class="card-body p-2" *ngIf="info">
              <div class="d-flex flex-column justify-content-start align-items-stretch">
                <app-your-betting-info [info]="info" [raceDate]="raceDate"
                  (clearAll)="clearAll()"></app-your-betting-info>
                <div class="d-flex flex-column justify-content-start align-items-stretch pt-4">
                  <form class="mb-4" [formGroup]="betService.raceDetailsForm">
                    <label class="mb-0">{{ "RACES.STAKES_IN" | translate }}
                      {{authService.currentCurrency$ |async
                      }}
                    </label>
                    <!-- <input class="stake-in text-center w-100"
                        [class.stake-red]="betService.raceDetailsForm.invalid === true"
                        formControlName="selectedStake"
                        [(ngModel)]="betService.selectedStake"
                        appTwoDigitDecimaNumber /> -->
                    <ng-container *ngIf="authService.currentCountry$ | async as country">
                      <p-dropdown [options]="country.stakes" [(ngModel)]="betService.selectedStake"
                        [ngModelOptions]="{ standalone: true }">
                        <ng-template pTemplate="selectedItem">
                          {{ betService.selectedStake | number: "1.2-2" }}
                        </ng-template>
                        <ng-template let-stakeItem pTemplate="stakeItem">
                          {{ stakeItem | number: "1.2-2" }}
                        </ng-template>
                      </p-dropdown>
                    </ng-container>
                  </form>
                  <!-- Bet Cart Price Info  -->
                  <ng-container *ngIf="betService.allAddedBetsInCart$.value.length > 0">
                    <ng-container *ngFor="let bet of allBetsOnCart$ | async">
                      <div class="d-flex flex-row justify-content-between align-items-center border-bottom my-1">
                        <div>
                          <span>{{ bet?.selectedBet?.name | bettingType | translate | capitalizeFirst}} : </span>
                          <span>{{ bet?.numberofBets }}</span>
                        </div>
                        <span>{{ bet?.totalPrice| number: "1.2-2" }}{{" "}}{{authService.currentCurrency$ |async
                          }}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>

                  <div class="d-flex flex-row justify-content-between align-items-center border-bottom my-1"
                    *ngIf="this.betService.showCurrentBet$ | async">
                    <div>
                      <span> {{ info?.selectedBet?.name | bettingType | translate| capitalizeFirst }}: </span>
                      <span>{{ betService.numberofBets}}</span>
                    </div>
                    <span>{{ betService.totalPrice | number: "1.2-2" }}{{" "}}{{authService.currentCurrency$ |async
                      }}
                    </span>
                  </div>

                  <div class="d-flex flex-row justify-content-between align-items-center my-1">
                    <div>
                      {{"Total" | translate}}
                    </div>
                    <span>{{ betService.totalAllBetsOnCart + betService.totalPrice | number: "1.2-2"
                      }}{{" "}}{{authService.currentCurrency$ |async
                      }}

                    </span>
                  </div>
                  <!--  Bet Cart Price Info  -->

                  <button *ngIf="!betService.showCurrentBet$.value && betService.allAddedBetsInCart$.value.length > 0"
                    class="btn btn-md btn-success text-center mt-4" (click)="showConfirmBetPopup()" [ngClass]="{
                      'kt-spinner kt-spinner--right kt-spinner--light':
                        betService.placeBetSpinner
                    }">
                    <i *ngIf="betService.placeBetSpinner" class="pi pi-spin pi-spinner text-primary mr-2"
                      style="font-size: 1.5rem"></i>
                    {{ "RACES.PLACE_BET" | translate }}
                  </button>

                  <button *ngIf="betService.showCurrentBet$.value || betService.allAddedBetsInCart$.value.length == 0"
                    [disabled]="
                      (info?.isFormValid === false ||
                      betService.numberofBets <= 0 ||
                      betService.placeBetSpinner
                      )

                    " class="btn btn-md btn-success text-center mt-4" (click)="showConfirmBetPopup()" [ngClass]="{
                      'kt-spinner kt-spinner--right kt-spinner--light':
                        betService.placeBetSpinner
                    }">
                    <i *ngIf="betService.placeBetSpinner" class="pi pi-spin pi-spinner text-primary mr-2"
                      style="font-size: 1.5rem"></i>
                    {{ "RACES.PLACE_BET" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
        <div class="space-10" *ngIf="bettingSlipStatus"></div>
        <!-- <app-accumulator *ngIf="!router.url.includes('/race/') || !bettingSlipStatus"></app-accumulator> -->
        <!-- <div class="space-10"></div> -->

        <app-top-wining [collapsed]="bettingSlipStatus"></app-top-wining>

        <app-opportunity *ngIf="!isHome && !router.url.includes('next-races/all')" [page]="'home'"
          [collapsed]="bettingSlipStatus" [sideCol]="true">
        </app-opportunity>

        <app-quarte-races *ngIf="!router.url.includes('races/all') || router.url.includes('next-races/all')"
          [collapsed]="bettingSlipStatus">
        </app-quarte-races>

        <!-- <app-starter-search></app-starter-search>
                        <div class="space-10"></div>
                        <app-head2head></app-head2head>
                        <div class="space-10"></div>
                        <app-side-more></app-side-more> -->
      </div>
    </div>
  </div>
</div>
<div class="sticky-footer d-xl-none" [class.slip-pinned]="bettingSlipStatus">
  <app-race-footer [cuponInfo]="info" [bettingSlipStatus]="bettingSlipStatus" [isFormValid]="false"
    [raceDate]="raceDate" [selectedBet]="info?.selectedBet?.name" (clearAll)="clearAll()">
  </app-race-footer>
</div>
<app-footer [class.footer-hidden-for-slip]="bettingSlipStatus" [hideLanguageToolbar]="isProviderLobby"></app-footer>
<!-- Reserves the height the pinned slip covers. It must sit AFTER the footer:
     placed before it, it padded the gap above the links and left the links
     themselves still underneath the pinned bar. -->
<div class="slip-spacer d-xl-none" *ngIf="bettingSlipStatus"></div>

<p-sidebar [(visible)]="leftMenu" [appendTo]="sidebarAppendTarget" [baseZIndex]="10000" styleClass="p-2 left-sidebar "
  [style]="{ width: '17em' }">
  <app-left-sidenav (closeLeftSidenav)="leftMenu = false"></app-left-sidenav>
</p-sidebar>

<p-sidebar [(visible)]="rightMenu" position="right" [appendTo]="sidebarAppendTarget" [baseZIndex]="10000" styleClass="p-2 right-sidebar "
  [style]="{ width: '19em' }">
  <app-right-sidenav (closeRightSidenav)="rightMenu = false" [userBalance]="userBalance" [username]="username">
  </app-right-sidenav>
</p-sidebar>

<!-- TOOLS. Both float over the content at the right edge. In lobby mode the
     vendor frame owns that edge (its betslip and history live there), so the
     language toggle and the Support tab step aside (the footer hides its own
     copy of the toggle through [hideLanguageToolbar]); both are back on
     every other route. -->
<app-language-toolbar class="d-desktop" *ngIf="!isProviderLobby"></app-language-toolbar>
<app-sticky-toolbar *ngIf="!isProviderLobby"></app-sticky-toolbar>